import Lenis from 'lenis'
import initReveal from './reveal'
import ButtonHover from "../../blocks/button/scripts";
import Contact from "../../blocks/contact/scripts";
import Newsletter from "../../blocks/footer/scripts";
import "../../blocks/three-card/scripts";
import "../../blocks/slider-brand/scripts";
import "../../blocks/slider-img/scripts";
import "../../blocks/slider/scripts";
import "../../blocks/banner/scripts";
import "../../blocks/list-testimonials/scripts";
import BlogList from "../../blocks/blog-list/scripts";
import Header from "../../blocks/header/scripts";
import SliderDescription from "../../blocks/slider-description/scripts";
import "../../blocks/title-text/scripts";

document.addEventListener('DOMContentLoaded', () => {

  console.log("hello  project");

  const lenis = new Lenis({
    lerp: 0.06,
    smoothWheel: true,
  })
  window.lenis = lenis
  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  const buttonElements = document.querySelectorAll('[data-block="button"]');
  buttonElements.forEach((buttonElement) => {
    new ButtonHover(buttonElement);
  });

  document.querySelectorAll('.contact').forEach((el) => {
    new Contact(el);
  });

  document.querySelectorAll('.footer').forEach((el) => {
    new Newsletter(el);
  });

  const header = document.querySelector('.header')
  if (header) new Header(header)

  document.querySelectorAll('[data-block="blog-list"]').forEach((el) => {
    new BlogList(el)
  })

  document.querySelectorAll('.slider-description').forEach((el) => {
    new SliderDescription(el)
  })

  initReveal()

  document.querySelectorAll('.header--switcher').forEach((el) => {
    el.addEventListener("click", () => {
      el.classList.toggle("isOpen")
    })
  });

});
